export default __webpack_public_path__ + "static/media/womens-top.8f9f4cf1.png";